import { StorageType } from "encamp-shared/src/constants/tierii";
import { storageTypeFields } from "encamp-shared/src/utils/storageTypeFields";
import { FacilityChemicalStorageLocationInput } from "generated-graphql/graphql";
import { v4 as uuid } from "uuid";

import { transform as transformStorageLocation } from "./transformStorageLocation";

export function transform(storageLocation: FacilityChemicalStorageLocationInput) {
  const { storageType, storageTypes } = storageTypeFields(storageLocation);
  return {
    id: storageLocation.id === "NEW" ? uuid() : storageLocation.id,
    storageLocation: transformStorageLocation(storageLocation.storageLocation),
    pressure: storageLocation.pressure,
    otherPressureValue: storageLocation.otherPressureValue,
    storageType,
    storageTypes,
    storageTypeDescription: storageTypes.includes(StorageType.Other)
      ? storageLocation.storageTypeDescription
      : null,
    temperature: storageLocation.temperature,
    unit: storageLocation.unit,
    maxAmount: storageLocation.maxAmount,
    averageAmount: storageLocation.averageAmount,
    maxAmountLargestContainer: storageLocation.maxAmountLargestContainer,
  };
}
